// @ts-nocheck
import styled from 'styled-components';

export const ReportsDownloadsTabStyle = styled.div`

  .reportsDownloadsTab {
    display: flex;
    gap: 8px;
    flex-direction: row;
    
    &__searchbarFilter, 
    &__dateFilter {
      float: left;
      width: 50%;
    }
  }
  .dateRangePickerContainer {
    flex: 0 0 auto;
  }
  .inputSearch {
    flex: 1 1 auto;
  }


`;
